export default __webpack_public_path__ + "static/media/sp-imone-boy.0040c85d.webp";